export default "__VITE_ASSET__DldQwpA1__"